import { NgModule } from '@angular/core';

import { CancelCustomerOrderDialogComponent } from './cancel-customer-order-dialog.component';

import { TranslateModule } from '@ngx-translate/core';

import { FuseSharedModule } from '@fuse/shared.module';
import { MaterialModule } from 'app/main/material.module';
import { DialogHeaderModule } from 'app/components/dialogs/dialog-header/dialog-header.module';

@NgModule({
    declarations: [
        CancelCustomerOrderDialogComponent,
    ],
    imports: [
        TranslateModule,
        FuseSharedModule,
        MaterialModule,
        DialogHeaderModule,
    ],
    exports: [
        CancelCustomerOrderDialogComponent,
    ]
})

export class CancelCustomerOrderDialogModule
{
}
